import PoiHandler from "./PoiHandler";
import utils from "../../app/utils";
import format from "../../app/format";
import layers from "../../app/layers";
import trans from "../../app/trans";
import rootScope from "../../app/rootScope";
import ObsWindowView from "./ui/ObsWindowView";
import ObsWindowController from "./ObsWindowController";
import overlays from "../../app/overlays";
import metar from "../../app/metar";

/**
 * Clase que maneja los datos de estaciones (StationDataHandler).
 * Extiende la funcionalidad de PoiHandler para gestionar estaciones meteorológicas.
 */
class StationDataHandler extends PoiHandler {
    /**
     * Constructor de la clase StationDataHandler.
     * Inicializa el mapeo de tipos de estaciones.
     */
    constructor() {
        super(...arguments);
        this.type2type = {
            metar: "AIRPORT",
            wmo: "WMOSTATION",
            dbuoy: "Drifting buoy",
            buoy: "Buoy",
            madis: "Madis station",
            pws: "Personal station"
        };
    }
    /**
     * Inicializa las propiedades específicas del controlador de estaciones.
     */
    initProperties() {
        super.initProperties();
        this.pluginIdent = "station";
        this.iconSizeX = 34;
        this.tileUrl = this.getTilesUrl();
    }
    /**
     * Obtiene la URL de las teselas para las estaciones.
     * @returns {string} La URL de las teselas.
     */
    getTilesUrl() {
        // return "http://localhost:8081/cgi-bin/otf_stations?z={z}&x={x}&y={y}";
        // return "https://test-services.meteored.com/cgi-bin/otf_stations?z={z}&x={x}&y={y}";
        return `${rootScope.poisURL}weather/{z}/{x}/{y}/`;
    }

    /**
     * Renderiza el contenido del popup para una estación.
     * @param {string} id - El identificador de la estación.
     * @param {Object} data - Los datos de la estación.
     * @returns {string} El contenido HTML del popup.
     */
    renderPopup(id, data) {

        const key = this.type2type[data.type];
        let type = trans[key];

        if (!type)
            type = trans["LASTUPDATE"];

        return `${data.name ? `<span class="station-name">${data.name.substring(0, 35)}</span>` : ""}<small>${type || data.type}: ${format.howOld({
            ts: data.ts,
            translate: true
        })}</small><div class="temp-wind">${this.wx2string2(data)}</div>`;
    }

    /**
     * Renderiza la ventana de observaciones de una estación.
     */
    renderObsWindow(){
        const obsWindow = document.querySelector('#stationobs');
        if(obsWindow){
            const obsWindowView = new ObsWindowView(obsWindow);
            const obsWindowController = new ObsWindowController(obsWindowView);
            this.controller= true;
        }
    }

    /**
     * Prepara los datos de una estación para su procesamiento.
     * @param {Object} data - Los datos de la estación.
     * @returns {Object} Los datos preparados.
     */
    prepareData(data) {
        const arrayRegex = /^(?:metar-([A-Z0-9]{4})|wmo-([0-9]{5}))$/.exec(data.id);
        // const arrayRegex = obsData.id.match(/^(?:([0-9]+)|metar-([A-Z0-9]{4})|wmo-([0-9]{5}))$/);
        let id = null;
        if(arrayRegex)
            id = arrayRegex[1] || arrayRegex[2];

        const key = this.type2type[data.type];
        let msg = trans[key];

        if (!msg)
            msg = trans["LASTUPDATE"];

        if (id){
            msg = `${msg} (ID: ${id})`;
        }

        data.msg = `${msg}, ${format.howOld({
            // diffMin: data.diff,
            ts: data.ts,
            translate: true
        })}`;


        let nvars = 0;

        if (data.obs1 !== null && data.obs1 !== undefined) {

            // if (data.obs2 !== null && data.obs2 !== undefined )
            //     data.obs1 += data.obs2;

            let obsmsg = metar(data.obs1);
            obsmsg = obsmsg.charAt(0).toUpperCase() + obsmsg.slice(1);

            if (data.obs2 !== null && data.obs2 !== undefined ){
                let obsmsg2 = metar(data.obs2);
                obsmsg2 = obsmsg2.charAt(0).toUpperCase() + obsmsg2.slice(1);
                obsmsg = obsmsg + " / " + obsmsg2;
            }


            console.info(data.obs1 + ": " + metar(data.obs1));

            const obs ={
                title: trans["OBSERVEDWEATHER"],
                value: obsmsg,
                color: null,
                icon: `${rootScope.resourcesServer}css/svgs/iconos_menu/search.svg`,
                class: 'aqi'
                // value
            }

            data.obs = obs;
            nvars+=2;
        }

        if(data.temp !== null && data.temp !== undefined) {
            const temp ={
                title: trans["TEMPERATURE"],
                value: layers.temp2m.m.convertValue.call(layers.temp2m.m, data.temp, " "),
                color: layers.temp2m.c.colorDark(data.temp, 20),
                icon: `${rootScope.resourcesServer}css/svgs/${overlays.temp2m.icon}`
            }
            data.temp = temp;

            nvars++;

        }


        if  (data.wind !== null && data.wind !== undefined) {

            let windValue = layers.viento.m.convertValue.call(layers.viento.m, data.wind, " ");
            let iconValue = false;
            if (utils.hasDirection(data)) {
                const windDirHtml = utils.windDir2html(data);
                windValue = `${windDirHtml}<span class="text">${data.dir}º / ${windValue}</span>`;
                iconValue = true;
            }

            const wind = {
                title: trans["WIND"],
                value: windValue,
                color: layers.viento.c.colorDark(data.wind, 20),
                iconValue: iconValue,
                icon: `${rootScope.resourcesServer}css/svgs/${overlays.viento.icon}`,
                class: 'wind'
            }

            data.wind = wind;

            nvars++;

        }

        if (data.prec !== null && data.prec !== undefined) {
            let precValue = layers.precip.m.convertValue.call(layers.precip.m, data.prec, " ");
            if (data.nprechours){
                precValue = `${precValue} / ${data.nprechours}h`;
            }

            const prec ={
                title: trans["PREC"],
                value: precValue,
                color: layers.precip.c.colorDark(data.prec, 20),
                icon: `${rootScope.resourcesServer}css/svgs/${overlays.precip.icon}`
            }
            data.prec = prec;

            nvars++;

        }

        if (data.visibility !== null && data.visibility !== undefined) {
            const visibility ={
                title: trans["VISIBILITY"],
                value: layers.visibilidad.m.convertValue.call(layers.visibilidad.m, data.visibility, " "),
                color: layers.visibilidad.c.colorDark(data.visibility, 20),
                icon: `${rootScope.resourcesServer}css/svgs/${overlays.visibilidad.icon}`
            }
            data.visibility = visibility;

            nvars++;

        }

        if (data.humidity !== null && data.humidity !== undefined) {
            const rh ={
                title: trans["RH"],
                value: layers.humedad.m.convertValue.call(layers.humedad.m, data.humidity, " "),
                color: layers.humedad.c.colorDark(data.humidity, 20),
                icon: `${rootScope.resourcesServer}css/svgs/${overlays.humedad.icon}`
            }
            data.humidity = rh;

            nvars++;
        }

        if (nvars <= 2)
            data.ncolumns = 1;
        else if (nvars <= 4)
            data.ncolumns = 2;
        else
            data.ncolumns = 3;


        return data;

    }

    /**
     * Convierte los datos meteorológicos de un POI a una cadena HTML.
     * @param {Object} poiData - Los datos del POI.
     * @returns {string} La cadena HTML generada.
     */
    wx2string2(poiData) {
        let html = "";
        return html;
    }

    /**
     * Actualiza los filtros de visualización de estaciones.
     */
    updateFilters() {
        // this.displayAdStations = store.get("displayAdStations");
        // this.displayWMOStations = store.get("displayWMOStations");
        // this.displayMadisPWStations = store.get("displayMadisPWStations");
        // this.displayShipStations = store.get("displayShipStations");
    }
    /**
     * Maneja el cambio en la visualización de estaciones.
     * Actualiza la URL de las teselas y reinicia la capa.
     */
    onDisplayChange() {
        // this.updateFilters();
        this.tileUrl = this.getTilesUrl();
        this.layer._reset.call(this.layer);
    }
    /**
     * Activa el controlador de datos de estaciones.
     * Actualiza los filtros y la URL de las teselas.
     */
    activate() {
        this.updateFilters();
        this.tileUrl = this.getTilesUrl();
        // store.on("displayAdStations", this.onDisplayChange, this);
        // store.on("displayWMOStations", this.onDisplayChange, this);
        // store.on("displayMadisPWStations", this.onDisplayChange, this);
        // store.on("displayShipStations", this.onDisplayChange, this);
        super.activate()
    }
    /**
     * Desactiva el controlador de datos de estaciones.
     */
    deactivate() {
        super.deactivate();
        // store.off("displayAdStations", this.onDisplayChange, this);
        // store.off("displayWMOStations", this.onDisplayChange, this);
        // store.off("displayMadisPWStations", this.onDisplayChange, this);
        // store.off("displayShipStations", this.onDisplayChange, this);
    }
}

export default StationDataHandler;
